"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL_ELEMENTS = exports.LABEL_SIZES = void 0;
var LABEL_SIZES = {
  NORMAL: "normal",
  LARGE: "large"
};
exports.LABEL_SIZES = LABEL_SIZES;
var LABEL_ELEMENTS = {
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
};
exports.LABEL_ELEMENTS = LABEL_ELEMENTS;